import { Box, DateInput as Input } from 'grommet'
import { CalendarIcon } from '../../../assets/svgs'

type Props = {
  value: string | string[]
  setValue: (e: any) => void
}

export const DateInput = ({ value, setValue }: Props) => {
  return (
    <Box align="center" direction="column" gap="large" height={'100%'} justify="center">
      <Input
        calendarProps={{ size: 'small' }}
        dropProps={{ stretch: false }}
        format="dd/mm/yyyy"
        icon={<CalendarIcon />}
        onChange={({ value }) => {
          // if (value === undefined) return setValue(new Date())
          setValue(value)
        }}
        placeholder={'dd/mm/yyyy'}
        style={{ minHeight: 'unset' }}
        value={value}
      />
    </Box>
  )
}
